import { useState } from 'react'

export default function useDomainList() {
  let [info, set] = useState(false);
  return [info, set];
}
